import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWalkNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12.825 5H10a1.25 1.25 0 00-1.198 1.605L9.659 9.5H7.161L5.419 7.867A3.204 3.204 0 003.227 7C1.997 7 1 7.997 1 9.227v8.606c0 .271-.088.534-.25.75l-.087.117a3.312 3.312 0 002.65 5.3h20.396c3.67 0 5.81-1.067 7.015-2.405 1.177-1.308 1.268-2.663 1.275-2.881v-.02l.001-.022v-.011a5.393 5.393 0 00-3.15-4.904l-6.195-2.832-5.768-4.522A6.584 6.584 0 0012.825 5zm-1.15 2.5h1.15c.914 0 1.801.306 2.52.87l1.908 1.497-1.653 2.48 2.08 1.386 1.546-2.32 1.092.857-1.385 2.077 2.08 1.386 1.436-2.153 4.427 2.023c-.38.276-.689.576-.953.833l-.044.042c-.708.687-1.092 1.022-1.879 1.022H3.5V9.555a.704.704 0 01.209.136L6.172 12h6.836zM2.81 20H24c1.842 0 2.87-.999 3.577-1.686l.044-.042c.593-.576.96-.905 1.526-.996.223.409.348.872.353 1.355-.01.091-.088.685-.634 1.29-.603.67-1.98 1.58-5.157 1.58H3.312a.813.813 0 01-.65-1.3l.088-.117A3.75 3.75 0 002.81 20z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWalkNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWalkNormalMedium;
